"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDafOrganizationReminderMockData = exports.buildDafDonationMockData = void 0;
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const icons_1 = require("../icons");
const build_daf_email_copy_1 = require("../helpers/build-daf-email-copy");
const organization_facing_base_1 = require("./organization-facing-base");
const organization_page_button_1 = require("./organization-page-button");
const buildDafDonationMockData = ({ orgName, color, isDarkMode, state, locale = "en", subject, body = "<p>Thank you for supporting our community.</p>", isOtherProvider = false, organizationPageUrl, }) => {
    const theme = (0, email_theme_tokens_1.resolveEmailThemeTokens)(color, isDarkMode ? "dark" : "light");
    return {
        ...(0, organization_page_button_1.buildOrganizationPageButtonMockFields)(organizationPageUrl, theme),
        ...(0, build_daf_email_copy_1.buildDafEmailCopy)({
            locale,
            provider: "Fidelity Charitable",
            organization: orgName,
            amount: "$2,000",
            donor: "Sammy Goyette",
        }),
        organizationEin: "37-4874848",
        organizationAddress: "PO Box 281, Clay Center, KS 67432",
        dafQuoteIcon: icons_1.EMAIL_ICON_DATA_URI.dafQuote,
        dafFacebookIcon: icons_1.EMAIL_ICON_DATA_URI.dafFacebook,
        dafLinkedinIcon: icons_1.EMAIL_ICON_DATA_URI.dafLinkedin,
        dafInstagramIcon: icons_1.EMAIL_ICON_DATA_URI.dafInstagram,
        labels: (0, email_templates_1.getEmailLabels)(locale),
        theme,
        orgName,
        lang: locale,
        iconZeffyLogo: theme.zeffyLogoVariant === "dark" ? icons_1.EMAIL_ICON_DATA_URI.zeffyDark : icons_1.EMAIL_ICON_DATA_URI.zeffyLight,
        firstName: "Sammy",
        donorFullName: "Sammy Goyette",
        donorLocation: "Boston, MA",
        subject: subject ??
            (state === "declared"
                ? "Thank you for your $2,000 donation!"
                : state === "received"
                    ? `${orgName} received your $2,000 donation via Fidelity Charitable!`
                    : "Need help confirming your donation with Fidelity Charitable?"),
        message: state !== "reminder" ? body : null,
        amount: "$2,000",
        donationDate: "September 25, 2026",
        providerName: isOtherProvider ? "your donor-advised fund" : "Fidelity Charitable",
        isOtherProvider,
        reference: "#Z000001",
        isDeclared: state === "declared",
        isReceived: state === "received",
        isReminder: state === "reminder",
        resumeUrl: "https://example.org/resume",
        providerEmailUrl: "mailto:provider@example.org",
        providerPortalUrl: "https://example.org/portal",
        donorDashboardUrl: "https://example.org/donations",
        currentYear: 2026,
    };
};
exports.buildDafDonationMockData = buildDafDonationMockData;
const buildDafOrganizationReminderMockData = (locale = "en") => ({
    ...(0, organization_facing_base_1.buildOrgFacingBase)(locale, "Someone may need your help to confirm a $2,000 donation"),
    ...(0, build_daf_email_copy_1.buildDafEmailCopy)({
        locale,
        provider: "Fidelity Charitable",
        organization: "Cerebral Palsy Foundation",
        amount: "$2,000",
        donor: "Sammy Goyette",
    }),
    theme: (0, build_daf_email_copy_1.getDafOrganizationEmailTheme)(),
    dafFacebookIcon: icons_1.EMAIL_ICON_DATA_URI.dafFacebook,
    dafLinkedinIcon: icons_1.EMAIL_ICON_DATA_URI.dafLinkedin,
    dafInstagramIcon: icons_1.EMAIL_ICON_DATA_URI.dafInstagram,
    iconZeffyLogo: icons_1.EMAIL_ICON_DATA_URI.zeffyLight,
    donorFullName: "Sammy Goyette",
    amount: "$2,000",
    providerName: "Fidelity Charitable",
    viewDonationUrl: "https://example.org/donation",
});
exports.buildDafOrganizationReminderMockData = buildDafOrganizationReminderMockData;
